const Loading = ({type = ''}) => {

  return (
    <div className={`loadingBox ${type}`}>
      <i className="icofont-ui-laoding" />
      <p>Loading...</p>
    </div>
  )
}

export default Loading